import { COPY_KO } from "./ko.js";
import { COPY_EN } from "./en.js";
import { COPY_JA } from "./ja.js";
import { COPY_ZH } from "./zh.js";
export * from "./catalog.js";
export { COPY_KO, COPY_EN, COPY_JA, COPY_ZH };
/** 언어별 기본 문구 — 콘솔 placeholder·web 폴백·검증 기준 */
export const DEFAULT_COPY = {
    ko: COPY_KO,
    en: COPY_EN,
    ja: COPY_JA,
    zh: COPY_ZH,
};
import { COPY_CATALOG } from "./catalog.js";
/** 오버라이드 값 1개 최대 글자 수 */
export const COPY_VALUE_MAX = 500;
/** 오버라이드 문서 JSON 최대 바이트 (DynamoDB 400KB 항목 한도 안) */
export const COPY_DOC_MAX_BYTES = 200_000;
/** "{n}" 형태 플레이스홀더 치환. params 에 없는 이름은 원문 그대로 둔다. */
export function interpolate(template, params) {
    return template.replace(/\{(\w+)\}/g, (match, name) => Object.prototype.hasOwnProperty.call(params, name) ? String(params[name]) : match);
}
/** 템플릿에 빠진 파라미터 이름 — 콘솔 경고용 */
export function missingPlaceholders(template, params) {
    return params.filter((p) => !template.includes(`{${p}}`));
}
const BRANDING_LANGS = new Set(["ko", "en"]);
/**
 * 한 언어의 최종 문구. 적용 순서: 기본 딕셔너리 → 브랜딩 텍스트(ko/en attractTitle/attractSubtitle) → 문구 오버라이드.
 * 브랜딩·오버라이드 모두 trim 후 빈 값은 "없음" 으로 취급한다. 입력은 변경하지 않는다.
 */
export function resolveCopy(lang, overrides, branding) {
    const out = { ...DEFAULT_COPY[lang] };
    if (branding && BRANDING_LANGS.has(lang)) {
        const l = lang;
        const title = branding.attractTitle?.[l]?.trim();
        const subtitle = branding.attractSubtitle?.[l]?.trim();
        if (title)
            out["attract.headline"] = title;
        if (subtitle) {
            out["attract.tagline"] = subtitle;
            out["common.brandCaption"] = subtitle;
        }
    }
    for (const entry of COPY_CATALOG) {
        const value = overrides[entry.key]?.[lang];
        if (typeof value === "string" && value.trim())
            out[entry.key] = value;
    }
    return out;
}
//# sourceMappingURL=index.js.map